import { TableCell } from '@mui/material';
import { styled } from '@mui/system';

const WideTableCellCenter = styled(TableCell)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export default WideTableCellCenter;
